<template>
  <div class="c-setting">
    <div v-if="!leTbS" class="c-title">
      <span><c-svg t="account-circle"></c-svg>{{ $T('page.mypage.title') }}</span>
    </div>

    <template v-if="setting_groups != null">
      <template v-for="(setting_group, index) in setting_groups">
        <div class="c-subtitle" :class="{ danger: setting_group.danger }">{{ setting_group.title }}</div>
        <div class="c-rows" :class="{ danger: setting_group.danger }">
          <setting-row
            v-for="setting in setting_group.settings"
            :ref="'setting-row-' + setting.id"
            :key="setting.id"
            :settingIndex="index"
            :settingKey="setting.id"
            :setting="setting"
            @click-button="onClickButton"
            @change-value="onChangeParam"
            @change-cover="onChangeCover"
          />
        </div>
      </template>
    </template>

    <single-input-dialog
      v-if="dialog.target != null"
      ref="single-input-dialog"
      :open="dialog.open"
      :dialogKey="dialog.target.id"
      :dialogType="dialog.target.dialogType"
      :dialogTitle="dialog.target.dialogTitle"
      :fieldName="dialog.target.id"
      :inputLabel="dialog.target.inputLabel"
      :initValue="dialog.target.value"
      :items="dialog.target.items"
      :itemText="dialog.target.itemText"
      :itemValue="dialog.target.itemValue"
      :veeValidate="dialog.target.veeValidate"
      :required="dialog.target.required"
      :counter="dialog.target.counter"
      :apiErrors="apiErrors"
      :onSending="sending"
      @close="onCloseDialog"
      @save="onChangeParam"
    />

    <my-birth-month-dialog
      v-if="originalDialog == 'my_birth_month'"
      ref="my-birth-month-dialog"
      :open="originalDialog == 'my_birth_month'"
      :initValue="getSetting('my_birth_month').value"
      :apiErrors="apiErrors"
      @close="onCloseDialog"
      @save="onChangeParam"
    />

    <confirm-dialog
      v-if="confirmDialog != null"
      ref="confirm-dialog"
      :open="confirmDialog != null"
      :dialogKey="confirmDialog.id"
      :dialogTitle="confirmDialog.title"
      :dialogText="confirmDialog.text"
      :confirmValue="confirmDialog.confirmValue"
      :errMsg="confirmDialog.errMsg"
      @cancel="onConfirmCancel"
      @ok="onConfirmOk"
    />
  </div>
</template>

<script>
import UTILS from '../../utils/utils';
import settingRow from '../common/SettingRow.vue';
import singleInputDialog from '../common/SingleInputDialog.vue';
import myBirthMonthDialog from './MyBirthMonthDialog.vue';
import confirmDialog from '../common/ConfirmDialog.vue';
import communityListDialog from '../common/CommunityListDialog.vue';
import selectCover from '../common/SelectCover.vue';
import { getMemberMyPageSetting, updateMemberSetting, updateCover } from '../../api/member';

export default {
  beforeRouteEnter(route, redirect, next) {
    console.log('beforeRouteEnter');
    UTILS.startLoading();
    getMemberMyPageSetting()
      .then(function(response) {
        UTILS.stopLoading();
        next(vm => vm.setSetting(response));
      })
      .catch(function(error) {
        UTILS.stopLoading();
        console.error('failed to get member data', error);
        next(error);
      });
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate');
    UTILS.startLoading();
    this.setting_groups = null;
    var _this = this;
    getMemberMyPageSetting()
      .then(function(response) {
        UTILS.stopLoading();
        _this.setSetting(response);
        next();
      })
      .catch(function(error) {
        UTILS.stopLoading();
        console.error('failed to get member data', error);
        next(error);
      });
  },
  methods: {
    setSetting(loadedSetting) {
      this.loaded_setting = loadedSetting;
      var copied = [];
      this.setting_map = null;
      this.setParam('my_name', 'value', loadedSetting.name);
      this.setParam('my_cover', 'value', loadedSetting.cover_path);
      this.setParam('my_email', 'value', loadedSetting.email);
      this.setParam(
        'my_email',
        'supplement',
        loadedSetting.changing_to ? $T('page.mypage.my_email.change.to', { address: loadedSetting.changing_to }) : ''
      );
      this.setParam('my_email', 'disabled', loadedSetting.changing_to ? true : false);
      this.setParam('my_birth_month', 'value', loadedSetting.birth_month);
      this.setParam('my_birth_month', 'disabled', loadedSetting.birth_month != null);
      this.setParam('my_gender', 'value', loadedSetting.gender);
      this.setParam('my_gender', 'disabled', loadedSetting.gender > 0);
      this.setting_groups = this.setting_groups_template;
    },
    setParam(key, param, value) {
      var setting = this.getSetting(key);
      if (setting == null)
        return console.error('failed to update param : ' + JSON.stringify({ key: key, param: param, value: value }));
      console.log(key + '.' + param + ' value : ' + setting[param] + ' => ' + value);
      setting[param] = value;
    },
    getSetting(key) {
      if (this.setting_map == null) {
        // create new map
        var map = {};
        for (var groupIdx in this.setting_groups_template) {
          for (var settingIdx in this.setting_groups_template[groupIdx].settings) {
            var setting = this.setting_groups_template[groupIdx].settings[settingIdx];
            if (map[setting.id] != null) {
              console.error(setting.id + ' is duplicated!');
              continue;
            }
            map[setting.id] = setting;
          }
        }
        this.setting_map = map;
      }
      var setting = this.setting_map[key];
      if (setting == null) {
        console.error(key + ' is not exist!');
      }
      return setting;
    },
    setValue(key, value) {
      this.$refs['setting-row-' + key][0].setValue(value);
      this.setParam(key, 'value', value);
    },
    setDisabled(key, value) {
      this.$refs['setting-row-' + key][0].setDisabled(value);
      this.setParam(key, 'disabled', value);
    },
    setSupplement(key, value) {
      if (key == 'my_email') {
        value = value ? $T('page.mypage.my_email.change.to', { address: value }) : '';
      }
      this.$refs['setting-row-' + key][0].setSupplement(value);
      this.setParam(key, 'supplement', value);
    },
    onChangeParam(settingKey, newParam, oldParam) {
      var setting = this.getSetting(settingKey);

      if (setting.dialogType == 'select' || setting.dialogType == 'text') {
        let data = {
          id: setting.id,
          value: newParam,
        };

        this.updateMemberSetting(
          data,
          component => {
            component.onCloseDialog();
          },
          (component, err) => {
            component.$refs['single-input-dialog'].reValidate();
          }
        );
      } else if (setting.id == 'my_birth_month' || setting.id == 'my_gender') {
        if (newParam != setting.value) {
          var dialog = {};
          dialog.id = setting.id;
          dialog.title = $T('common.set_attribute.title', { attr: setting.title });
          dialog.text = $T('common.set_attribute.text', { attr: setting.title, v: setting.editValue(this, newParam) });
          dialog.confirmValue = newParam;
          dialog.open = true;
          this.confirmDialog = dialog;
        } else {
          console.log(settingKey + ' changed to same value [' + newParam + ']');
        }
      } else if (setting.id == 'my_cover') {
        // do nothing
      } else {
        console.error('failed to do process for settingKey [' + settingKey + ']');
      }
    },
    onClickButton(settingKey) {
      var setting = this.getSetting(settingKey);
      if (setting.dialogType == 'text' || setting.dialogType == 'select') {
        this.dialog.target = setting;
        this.dialog.open = true;
      } else if (setting.dialogType == 'original') {
        if (settingKey == 'my_cover') {
          var _this = this;
          UTILS.startLoading();
          getCovers()
            .then(function(response) {
              UTILS.stopLoading();
              _this.coverImgs = response;
              _this.originalDialog = 'my_cover';
            })
            .catch(function(error) {
              UTILS.stopLoading();
              console.error('failed to get cover data', error);
            });
        } else {
          this.originalDialog = setting.id;
        }
      } else {
        console.error('Unknown dialogType [' + setting.dialogType + ']');
      }
    },
    onCloseDialog(settingKey) {
      this.dialog.open = false;
      this.dialog.target = null;
      this.apiErrors = {};
      this.originalDialog = null;
      this.sending = false;
      this.onCloseConfirmDialog();
    },
    onConfirmOk(settingKey, confirmValue) {
      let data = {
        id: settingKey,
        value: confirmValue,
      };

      this.updateMemberSetting(
        data,
        component => {
          component.setDisabled(data.id, true);
          component.onCloseDialog();
        },
        (component, err) => {
          component.$refs['confirm-dialog'].setErrMsg(component.apiErrors[data.id][data.value]);
        }
      );
    },
    onCloseConfirmDialog(settingKey) {
      this.apiErrors = {};
      this.confirmDialog = null;
      this.sending = false;
    },
    onConfirmCancel(settingKey, confirmValue) {
      this.$refs['setting-row-' + settingKey][0].resetValue();
      this.onCloseConfirmDialog(settingKey);
    },
    updateMemberSetting(data, successCallback, errorCallback) {
      this.sending = true;
      var _this = this;
      updateMemberSetting(data)
        .then(function(response) {
          _this.sending = false;
          if (data.id == 'my_email') {
            _this.setSupplement(data.id, data.value);
            _this.setDisabled(data.id, true);
          } else {
            _this.setValue(data.id, data.value);
          }
          if (successCallback) {
            successCallback(_this);
          }
        })
        .catch(function(error) {
          console.log(error);

          var setting = _this.getSetting(data.id);
          console.log('set setting api errors');
          if (!_this.apiErrors[setting.id]) {
            _this.apiErrors[setting.id] = {};
          }

          if (error.errors && (error.errors.id || error.errors.value)) {
            _this.apiErrors[setting.id][data.value] = error.errors.id ? error.errors.id[0] : error.errors.value[0];
          } else {
            _this.apiErrors[setting.id][data.value] = _this.$T('error.unknown');
          }
          _this.sending = false;
          if (errorCallback) {
            errorCallback(_this, error);
          }
        });
    },
    onChangeCover(settingKey, selectCoverVue) {
      UTILS.startLoading();
      var data = new FormData();
      data.append('selectedPath', selectCoverVue.path);
      selectCoverVue.appendDeletedCoversToForm(data, 'deletedPathes');
      selectCoverVue.appendNewCoversToForm(data, 'files');
      var _this = this;
      updateCover(data)
        .then(function(response) {
          var path = response.cover_path;
          _this.setValue('my_cover', path);
          _this.$store.commit('SET_COVER', path);
          UTILS.stopLoading();
          _this.originalDialog = null;
          selectCoverVue.resetPath(path);
        })
        .catch(function(error) {
          UTILS.stopLoading();
          console.error('failed to update cover data', error);
        });
    },
  },
  components: {
    'setting-row': settingRow,
    'single-input-dialog': singleInputDialog,
    'select-cover': selectCover,
    'my-birth-month-dialog': myBirthMonthDialog,
    'confirm-dialog': confirmDialog,
  },
  data() {
    return {
      dialog: {
        open: false,
        target: null,
      },
      confirmDialog: null,
      originalDialog: null,
      coverImgs: null,
      apiErrors: {},
      sending: false,
      loaded_settings: null,
      setting_map: null,
      setting_groups: null,
      setting_groups_template: [
        {
          title: $T('page.mypage.sub_title.basic_setting'),
          settings: [
            {
              id: 'my_name',
              type: 'value-button',
              title: $T('attributes.my_name'),
              explain: $T('page.mypage.my_name.explain'),
              supplement: $T('page.setting.supplement.community.default'),
              value: '',
              disabled: false,
              dialogType: 'text',
              dialogTitle: $T('common.change_attribute', { attr: $T('attributes.my_name') }),
              inputLabel: $T('attributes.my_name'),
              veeValidate: 'max:50',
              required: false,
              counter: 50,
            },
            {
              id: 'my_cover',
              type: 'cover',
              title: $T('attributes.my_cover'),
              explain: $T('page.mypage.my_cover.explain'),
              supplement: $T('page.setting.supplement.community.default'),
              value: '',
              disabled: false,
              dialogType: 'original',
            },
            {
              id: 'my_email',
              type: 'value-button',
              title: $T('attributes.my_email'),
              explain: $T('page.mypage.my_email.explain'),
              supplement: '',
              value: '',
              disabled: false,
              dialogType: 'text',
              dialogTitle: $T('common.change_attribute', { attr: $T('attributes.my_email') }),
              inputLabel: $T('attributes.my_email'),
              veeValidate: 'required|email',
              required: true,
              counter: 200,
            },
          ],
        },
        {
          title: $T('page.mypage.sub_title.attr_setting'),
          settings: [
            {
              id: 'my_birth_month',
              type: 'value-button',
              title: $T('attributes.my_birth_month'),
              explain: $T('page.mypage.my_birth_month.explain'),
              supplement: $T('page.mypage.no_change'),
              value: '',
              editValue: function(component, value) {
                return $T('common.year_month', {
                  y: value.substr(0, 4),
                  m: $T('common.month.' + Number(value.substr(4, 2))),
                });
              },
              disabled: false,
              dialogType: 'original',
            },
            {
              id: 'my_gender',
              type: 'radio',
              title: $T('attributes.my_gender'),
              explain: $T('page.mypage.my_gender.explain'),
              supplement: $T('page.mypage.no_change'),
              value: 1,
              items: [
                { value: 0, label: $T('params.not.set') },
                { value: 1, label: $T('params.gender.male') },
                { value: 2, label: $T('params.gender.female') },
                { value: 3, label: $T('params.gender.other') },
              ],
              editValue: function(component, value) {
                let setting = component.getSetting('my_gender');
                for (let item of setting.items) {
                  if (item.value == value) return item.label;
                }
                log.warn('there is no param [' + value + '] for my_gender');
                return null;
              },
              disabled: false,
            },
          ],
        },
      ],
    };
  },
};
</script>
